import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";

import { nextTick, onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useSearchStore } from "@/pinia/search";
import { LogService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'HideSearchFormButton',
  setup(__props) {

const searchStore = useSearchStore();
const { searchFormIsHidden: isHidden } = storeToRefs(searchStore);

watch(isHidden, () => {
  hide();
});
const hide = () => {
  const elements = document.querySelectorAll<HTMLElement>(
    ".collapsable-search"
  );
  const tabs = document.getElementById("search-tabs"); // need to grab this to adjust the min-width of the tabs
  if (!tabs) {
    LogService.error("Could not find search tabs to hide");
    return;
  }
  if (!isHidden.value) {
    // remove the min-width when setting back to normal
    tabs.style.minWidth = "0px";
    elements.forEach((element) => {
      element.style.display = "flex";
    });
  } else {
    // since we are hiding the search form we need to set a min-width since it is originally dynamic
    tabs.style.minWidth = `${initialWidth.value}px`;
    elements.forEach((element) => {
      element.style.display = "none";
    });
  }
};

const initialWidth = ref(0);
onMounted(() => {
  nextTick(() => {
    initialWidth.value =
      document.getElementById("search-tabs")?.offsetWidth ?? 0;
    if (initialWidth.value === 0) {
      LogService.error("Could not find search tabs to get initial width");
    }
  });
});

return { __sfc: true,searchStore, isHidden, hide, initialWidth, NjBtn }
}

})